import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReactComponent as IconCheck } from '../../../../assets/images/check.svg';
import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import Button, { ButtonKind } from '../button/Button';

const RequestSendSuccess: FC<{ close: () => void }> = ({ close }) => {
    const intl = useIntl();

    return (
        <div className="request-form__wrapper">
            <div className="request-form__header-success">
                <Button kind={ButtonKind.LINK} onClick={close}>
                    <IconClose width="14" height="14" />
                </Button>
            </div>

            <div className="request-form__body-success">
                <IconCheck />

                <h4>{intl.formatMessage({ id: 'modals.titleRequestSend', defaultMessage: 'Anfrage gesendet' })}</h4>

                <p>
                    {intl.formatMessage({
                        id: 'modals.descriptionRequestSend',
                        defaultMessage:
                            'Vielen Dank für Ihre Anfrage. Wir nehmen so rasch wie möglich Konktakt mit Ihnen auf.',
                    })}
                </p>

                <Button onClick={close}>{intl.formatMessage({ id: 'modals.okBtn', defaultMessage: 'OK' })}</Button>
            </div>
        </div>
    );
};

export default RequestSendSuccess;
